export default "__VITE_ASSET__Bsi4WQpV__"